import { useState, } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useAuth0 } from "@auth0/auth0-react";

import styles from './home.module.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Stack from 'react-bootstrap/Stack';
import { Tooltip } from "react-tooltip";
import 'react-tooltip/dist/react-tooltip.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faCheck, faCalendarWeek, faRoute, faMapLocationDot, faNoteSticky } from '@fortawesome/free-solid-svg-icons';

import ReviewsCarousel from './ReviewsCarousel';
import FeaturedItem from './FeaturedItem';
import IntroNav from '../Nav/Intro_Nav';
import ScrollAnimation from '../Animation/Scroll_Animation';
import ScrollAnimation2 from '../Animation/Scroll_Animation2';
import Divider from '../Utility/Divider';

import ScrollAnimationSingle from '../Animation/Scroll_Animation_Single';
import FloatingModal from '../Modals/Floating_Modal';
import Waitlist from '../../Modal_Components/Waitlist';
import Footer from './Footer';

const Home = () => {
  const { loginWithRedirect } = useAuth0();
  const isSmallScreen = useMediaQuery({ maxWidth: 576 });
  const secondary = 'var(--secondary)';
  const [show, setShow] = useState(false);
  const [waitlist, setwaitlist] = useState(false);

  const APKUrl = "https://play.google.com/store/apps/details?id=host";
  const IOSUrl = "https://apps.apple.com/us/app/expo-go/id982107779";
  
  const handleClose = () => {
    setShow(false);
    setwaitlist(false);
  }

  const handleWaitlist = () => {
    setwaitlist(true);
  }

  const signUpBtn = () => {
    return (
      <div className={`pt-1 d-flex justify-content-left align-items-left`}>
       <button
          className="ctaPrimaryBtn"
          onClick={() =>
            loginWithRedirect({
              authorizationParams: { screen_hint: 'signup',},
            })
          }
        >
          Start for Free
        </button>
      </div>
    );
  }

  const signUpBtnSecondary = () => {
    return (
      <div className={`pt-1 d-flex justify-content-left align-items-left`}>
       <button
          className="ctaSecondaryBtn"
          onClick={() =>
            loginWithRedirect({
              authorizationParams: { screen_hint: 'signup',},
            })
          }
        >
          Start for Free
        </button>
      </div>
    );
  }

  const signUpBtnApps = () => {
    return(
      <div className="d-flex flex-column">
        <div className="d-flex flex-column flex-md-row justify-content-start justify-content-md-center gap-4 align-items-center pt-2 pb-1">
          <a href="https://apps.apple.com/us/app/myschedulepal/id6745926865" target="_blank" rel="noreferrer" aria-label="Download on the App Store">
            <img src="/assets/icons/appstore_btn.svg" alt="App Store" style={{ height: 54 }} />
          </a>

          <a href="https://play.google.com/store/apps/details?id=com.myschedulepal.mspmobile&hl=en_US" target="_blank" rel="noreferrer" aria-label="Download on the Google Play Store">
            <img src="/assets/images/googleplay_btn.png" alt="Google Play" style={{ height: 54 }} />
          </a>
        </div>
        <p className="my-1">Download the App for Free</p>
      </div>
    );
  }

  const mobileAppLink = () => {
    return (
      <div className={`pt-1 d-flex justify-content-left align-items-left`}>
        <a href='https://apps.apple.com/us/app/myschedulepal/id6745926865' target='_blank' className="ctaSecondaryBtn">Download the App</a>
      </div>
    );
  }

  const featureItem = (icon, title, content) => {
    return (
      <div className='h-100'>
        <div className={`${styles.featureItem} d-flex h-100`}>
          {icon}
          <h4 className={`${styles.purpleTitle} p-2`}>{title}</h4>
          {title === "" ? <p>(Coming Soon)</p> : null}
          <div className={styles.featureContent}>
            {content}
          </div>
        </div>
      </div>
    );
  }

  const mainTitle = () => {
    return (
      <div
        id="home"
        className={`${styles.custTitleContainer} ${styles.gradientFlatBottomToTop} d-flex flex-column justify-content-center align-items-center py-5`}
      >
        <Container>
          <div className="d-flex flex-column justify-content-center align-items-center text-center w-100 pt-5 pb-1">
            <div className={styles.titleCol}>
              <div className={`${styles.titleContainer} py-3`}>
                <h1 className={styles.heroTitle} style={{ color: "var(--mainText)" }}>
                  Schedule Home Health Visits 75% Faster
                </h1>
              </div>
              <div className={`${styles.titleContainer} pb-3`}>
                <div className={`${styles.heroSubtitle}`}>
                  Therapists use MySchedulePal to focus on what matters most.
                </div>
              </div>
              {/* For large Screens */}
              {signUpBtnApps()}
              
            </div>
          </div>
        </Container>
        <ReviewsCarousel 
          autoPlayDefault={true} 
          interval={4500} 
        />
      </div>
    );
  };

  const features = () => {
    return (
      <Container className='py-5'>
        {/* <Stack>
          <div className={`d-flex justify-content-start align-items-start w-100 flex-column`}>
            <div className={`${styles.heroSecondaryTitle} ${styles.mainTextColor} ${styles.halfWidth} d-flex align-items-center pb-3`}>More time for care. Less time scheduling.</div>
            <div className={`${styles.heroSubtitle} text-left pb-3`}>Combine all your scheduling needs into one platform.</div>
            {signUpBtnSecondary()}
          </div>
          <ScrollAnimationSingle 
            component={<Container className='py-5'>
              <Row className='py-4'>
                <Col xs={12} md={6} className={styles.smallerFeatureScreen}>
                  {featureItem(
                    <FontAwesomeIcon icon={faCalendarWeek} style={{ color: "var(--primary)" }} size="3x" />,
                    "Test Drive-Time Viability",
                    "Stop using google maps to constantly type in one address at a time, testing the drive time sequentially. Quickly edit your schedule and instantly test which visits will work in terms of drive time viability.",
                  )}
                </Col>
                <Col xs={12} md={6}>
                  {featureItem(
                    <FontAwesomeIcon icon={faMapLocationDot} style={{ color: "var(--primary)" }} size="3x" />,
                    "Automatic Grouping",
                    "No more staring at the map trying to figure out which patients should be seen together. Sometimes, the groups you establish don't even work because of scheduling conflicts. We'll do the heavy lifting while you focus on getting the patient to answer the phone!",
                  )}
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6} className={styles.smallerFeatureScreen}>
                  {featureItem(
                    <FontAwesomeIcon icon={faRoute} style={{ color: "var(--primary)" }} size="3x" />,
                    "Efficient Routing",
                    "Save time and gas money by finding the most efficient route for your day. Not all of your patients will agree to the route but it's a great place to start!",
                  )}
                </Col>
                <Col xs={12} md={6}>
                  {featureItem(
                    <FontAwesomeIcon icon={faNoteSticky} style={{ color: "var(--primary)" }} size="3x" />,
                    "Track Patient Info",
                    `Patients tend to have odd requests. "I can't be seen before 10am, Use the side door, I have physical therapy on Tuesdays". Keep all these notes in one place, no need to review/keep old notes or look at several different tools. Keep it here.`,
                  )}
                </Col>
              </Row>
            </Container>}
            time={1000}
          />
        </Stack> */}
        <Stack>
          <div className={`d-flex justify-content-start align-items-start w-100 flex-column`}>
            <div className={`${styles.heroSecondaryTitle} ${styles.mainTextColor} ${styles.halfWidth} d-flex align-items-center pb-3`}>More time for care. Less time scheduling.</div>
            <div className={`${styles.heroSubtitle} text-left pb-3`}>Combine all your scheduling needs into one platform.</div>
            {signUpBtnApps()}
          </div>

          <ScrollAnimationSingle
            animateIn="fadeIn"
            animateOut="fadeOut"
            duration={1000}
            component={<FeaturedItem
              img="/assets/images/grouped_pts.png"
              title="Automatic Geographic Grouping"
              explanation="No more staring at the map trying to figure out which patients should be seen together. All your patients, on one map, grouped geographically. Viola!"
              direction="left"
              imgAlt="Automatic Geographic Grouping Feature Image"
              className="py-5"
            />}
          />

          <ScrollAnimationSingle
            animateIn="fadeIn"
            animateOut="fadeOut"
            duration={1000}
            component={<FeaturedItem
              img="/assets/images/optimized_routing.png"
              title="Optimized Routing"
              explanation="Save time and money by finding the most efficient route for your day. Adjust on the fly, viewing how change in appointment order affects your overall route."
              direction="right"
              imgAlt="Optimized Routing Feature Image"
              className="py-5"
            />}
          />

          <ScrollAnimationSingle
            animateIn="fadeIn"
            animateOut="fadeOut"
            duration={1000}
            component={<FeaturedItem
              img="/assets/images/mobile_cal.png"
              title="Smart Calendar"
              explanation="Test the drive time viability of your schedule with a single click. Quickly edit your schedule and instantly see which visits will work in terms of drive time. We will be adding smart AI scheduling next!"
              direction="left"
              imgAlt="Smart Calendar Feature Image"
              className="py-5"
            />}
          />
        </Stack>
      </Container> 
    );
  }

  const pricing = () => {
    const title = () => {
      return (
        <div className='d-flex flex-column justify-content-center align-items-center'>
          <div className={`${styles.heroSecondaryTitle} ${styles.mainTextLightColor} text-center pb-3`}>Get Early Access</div>
          <div className={`${styles.heroSubtitle} ${styles.mainTextLightColor} text-center pb-3`}>
            MySchedulePal is free while we’re in early access.
          </div>
        </div>
      );
    }

    const pricingLite = () => {
      return (
        <div className={`d-flex flex-column justify-content-end align-items-start ${styles.pricingBox}`}>
          <div className={`${styles.saSubtitle} ${styles.mobilePricingPadding} p-2`}>Lite</div>
          <div className={`${styles.contentPricing} ${styles.mobilePricingPadding} p-2`}><span className='me-2'><FontAwesomeIcon color={secondary} icon={faCheck} /></span>Auto Geographic Grouping</div>
          <div className={`${styles.contentPricing} ${styles.mobilePricingPadding} p-2`}><span className='me-2'><FontAwesomeIcon color={secondary} icon={faCheck} /></span>Optimized Routing</div>
          <div className={`${styles.contentPricing} ${styles.mobilePricingPadding} p-2`}><span className='me-2'><FontAwesomeIcon color={secondary} icon={faCheck} /></span>Scheduling Notes</div>
          <div className={`${styles.contentPricing} ${styles.mobilePricingPadding} p-2`}><span className='me-2'><FontAwesomeIcon color={secondary} icon={faCheck} /></span>Free</div>
          {/* <div className={`p-2 d-flex justify-content-center align-items-center`}>
            {mobileAppLink()}
          </div> */}
        </div>
      );
    }

    const pricingPremium = () => {
      return (
        <div className={`d-flex flex-column justify-content-end align-items-start ${styles.pricingBox}`}>
          <div className={`${styles.saSubtitle} ${styles.mobilePricingPadding} p-2`}>Coming Soon</div>
          <div className={`${styles.contentPricing} ${styles.mobilePricingPadding} p-2`}><span className='me-2'><FontAwesomeIcon color={secondary} icon={faCheck} /></span>Calendar Suggestions</div>
          <div className={`${styles.contentPricing} ${styles.mobilePricingPadding} p-2`}><span className='me-2'><FontAwesomeIcon color={secondary} icon={faCheck} /></span>Mileage Tracking</div>
          <div className={`${styles.contentPricing} ${styles.mobilePricingPadding} p-2`}><span className='me-2'><FontAwesomeIcon color={secondary} icon={faCheck} /></span>Track Visits With Tags</div>
          <div className={`${styles.contentPricing} ${styles.mobilePricingPadding} p-2`}><span className='me-2'><FontAwesomeIcon color={secondary} icon={faCheck} /></span>AI Smart Scheduling</div>
          <div className={`p-2 d-flex justify-content-center align-items-center`}>
          {/* {mobileAppLink()} */}
          </div>
        </div>
      );
    }

    const lastLine = () => {
      return (
        <div className={`${styles.heroSubtitle} ${styles.mainTextColor} text-center pb-3`}>No fees. No credit card. Just more time focusing on what matters most.</div>
      );
    }

    return (
      <Container className={`${styles.allPricingContents} py-5`}>
        <ScrollAnimation title={title()} first={pricingLite()} second={pricingPremium()} third={lastLine()} />
      </Container>
    );
  }

  const hipaa = () => {
    return (
      <ScrollAnimation2 widget={
        <Container className='d-lg-flex d-block justify-content-around align-items-center'>
          <div className={`${styles.hipaaExplanation} d-flex flex-column justify-content-start align-items-start`}>
            <div className={`${styles.heroSecondaryTitle} pb-2 text-left`}>HIPAA Compliant</div>
            <div className={`${styles.heroParagraph} text-left`}>
              Top-notch encryption and security to keep your health info (PHI) locked down—because HIPAA says so, and we take that seriously! All BAAs are in place and ready to go.
            </div>
          </div>

          <div className="d-flex flex-column justify-content-start align-items-start pt-3">
            <div className={`${styles.heroSubtitle} p-2`}><span className='me-2'><FontAwesomeIcon color={secondary} icon={faCheck} /></span>Business Associate Agreements</div>
            <div className={`${styles.heroSubtitle} p-2`}><span className='me-2'><FontAwesomeIcon color={secondary} icon={faCheck} /></span>Top Notch Encryption</div>
            <div className={`${styles.heroSubtitle} p-2`}><span className='me-2'><FontAwesomeIcon color={secondary} icon={faCheck} /></span>MFA</div>
          </div>
        </Container>
      } />
      
    );
  }

  const callToAction = () => {
    return (
      <ScrollAnimation2 widget={
        <Container className='py-5'>
          <Row>
            <Col xs={12} className='d-flex flex-column justify-content-center align-items-center'>
              <div className={`${styles.heroSecondaryTitle} pt-4 pb-2 text-center`} style={{ color: "var(--primary)" }}>Focus on What Matters Most</div>
              <div className={`${styles.heroSubtitle} text-center pb-4`}>Family, Friends and Patient Care.</div>
              <div className="d-flex flex-column justify-content-start justify-content-md-center align-items-center">
                <div className="d-flex flex-column flex-md-row justify-content-center gap-4 align-items-center pt-2 pb-1">
                  <a href="https://apps.apple.com/us/app/myschedulepal/id6745926865" target="_blank" rel="noreferrer" aria-label="Download on the App Store">
                    <img src="/assets/icons/appstore_btn.svg" alt="App Store" style={{ height: 54 }} />
                  </a>

                  <a href="https://play.google.com/store/apps/details?id=com.myschedulepal.mspmobile&hl=en_US" target="_blank" rel="noreferrer" aria-label="Download on the Google Play Store">
                    <img src="/assets/images/googleplay_btn.png" alt="Google Play" style={{ height: 54 }} />
                  </a>
                </div>
                <p className="my-1">Download the App for Free</p>
              </div>
            </Col>
          </Row>
        </Container>
      } />
      
    );
  }

  return (
    <Container-Fluid>
      <IntroNav />
      <Stack className={styles.body}>
        {mainTitle()}
        <div className={`${styles.featureContainer} d-flex flex-column`}  id='features'>
          {features()}
        </div>
        <div className={`${styles.pricingContainer} ${styles.gradientFlatTopToBottom} d-flex flex-column`} id='pricing'>          
          {pricing()}
        </div>
        <div className={`${styles.gradientSecondaryFlatBottomToTop} d-flex flex-column`}>
          <div className="py-3 d-flex flex-column" id='hipaa'>
            {hipaa()}
          </div>
          <div className={`${styles.actionContainer} d-flex flex-column`}>          
            {callToAction()}
          </div>
          <Divider />
          <Footer />
        </div>
      </Stack>
    </Container-Fluid>
  );
}

export default Home;
